import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { VisitedProvider } from './context/VisitedContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <VisitedProvider>
        <App />
      </VisitedProvider>
    </BrowserRouter>
  </React.StrictMode>
);
